export class AIChatProtocolError extends Error {
  conversationId?: string;

  constructor(message: string, conversationId?: string) {
    super(message);
    this.name = 'AIChatProtocolError';
    this.conversationId = conversationId;
  }
}
